// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R2faVerifyRouteImport } from './routes/2fa-verify'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AiSysteemHusselTossRouteImport } from './routes/ai-systeem-hussel-toss'
import { Route as AlgemeneVoorwaardenRouteImport } from './routes/algemene-voorwaarden'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AutomatischIndelenTennisspelersRouteImport } from './routes/automatisch-indelen-tennisspelers'
import { Route as ClubRegisterRouteImport } from './routes/club-register'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DraaiboekHusselavondRouteImport } from './routes/draaiboek-husselavond'
import { Route as EmailPreviewRouteImport } from './routes/email-preview'
import { Route as HoeWerktHetRouteImport } from './routes/hoe-werkt-het'
import { Route as HusselIndelingenSysteemRouteImport } from './routes/hussel-indelingen-systeem'
import { Route as HusselavondOrganiserenRouteImport } from './routes/husselavond-organiseren'
import { Route as HusselenVsTossenVsRacketTrekkenRouteImport } from './routes/husselen-vs-tossen-vs-racket-trekken'
import { Route as HusselochtendOrganiserenRouteImport } from './routes/husselochtend-organiseren'
import { Route as JeugdHusselavondOrganiserenRouteImport } from './routes/jeugd-husselavond-organiseren'
import { Route as OverDeHusselAppRouteImport } from './routes/over-de-hussel-app'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PrivacyWebsiteRouteImport } from './routes/privacy-website'
import { Route as RacketTrekkenOrganiserenRouteImport } from './routes/racket-trekken-organiseren'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ScreenshotsRouteImport } from './routes/screenshots'
import { Route as TennisHusselAppRouteImport } from './routes/tennis-hussel-app'
import { Route as TennisTossAppRouteImport } from './routes/tennis-toss-app'
import { Route as TennisclubSoftwareRouteImport } from './routes/tennisclub-software'
import { Route as TennisverenigingAppSpelersRouteImport } from './routes/tennisvereniging-app-spelers'
import { Route as TossIndelingenSysteemRouteImport } from './routes/toss-indelingen-systeem'
import { Route as TossavondOrganiserenRouteImport } from './routes/tossavond-organiseren'
import { Route as TossochtendOrganiserenRouteImport } from './routes/tossochtend-organiseren'
import { Route as WatIsHusselenRouteImport } from './routes/wat-is-husselen'
import { Route as WatIsTossenRouteImport } from './routes/wat-is-tossen'
import { Route as SlugRegisterRouteImport } from './routes/$slug/register'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminHandleidingRouteImport } from './routes/_authenticated/admin-handleiding'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedScheduleRouteImport } from './routes/_authenticated/schedule'
import { Route as BlogHusselavondZonderVrijwilligersRouteImport } from './routes/blog/husselavond-zonder-vrijwilligers'
import { Route as BlogMeerSpelersNaarHusselavondRouteImport } from './routes/blog/meer-spelers-naar-husselavond'
import { Route as NieuwsIndexRouteImport } from './routes/nieuws/index'
import { Route as NieuwsSlugRouteImport } from './routes/nieuws/$slug'
import { Route as AuthenticatedEnrollSessionIdRouteImport } from './routes/_authenticated/enroll/$sessionId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R2faVerifyRoute = R2faVerifyRouteImport.update({
            id: '/2fa-verify',path: '/2fa-verify',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AiSysteemHusselTossRoute = AiSysteemHusselTossRouteImport.update({
            id: '/ai-systeem-hussel-toss',path: '/ai-systeem-hussel-toss',getParentRoute: () => rootRouteImport
          })
const AlgemeneVoorwaardenRoute = AlgemeneVoorwaardenRouteImport.update({
            id: '/algemene-voorwaarden',path: '/algemene-voorwaarden',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AutomatischIndelenTennisspelersRoute = AutomatischIndelenTennisspelersRouteImport.update({
            id: '/automatisch-indelen-tennisspelers',path: '/automatisch-indelen-tennisspelers',getParentRoute: () => rootRouteImport
          })
const ClubRegisterRoute = ClubRegisterRouteImport.update({
            id: '/club-register',path: '/club-register',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const DraaiboekHusselavondRoute = DraaiboekHusselavondRouteImport.update({
            id: '/draaiboek-husselavond',path: '/draaiboek-husselavond',getParentRoute: () => rootRouteImport
          })
const EmailPreviewRoute = EmailPreviewRouteImport.update({
            id: '/email-preview',path: '/email-preview',getParentRoute: () => rootRouteImport
          })
const HoeWerktHetRoute = HoeWerktHetRouteImport.update({
            id: '/hoe-werkt-het',path: '/hoe-werkt-het',getParentRoute: () => rootRouteImport
          })
const HusselIndelingenSysteemRoute = HusselIndelingenSysteemRouteImport.update({
            id: '/hussel-indelingen-systeem',path: '/hussel-indelingen-systeem',getParentRoute: () => rootRouteImport
          })
const HusselavondOrganiserenRoute = HusselavondOrganiserenRouteImport.update({
            id: '/husselavond-organiseren',path: '/husselavond-organiseren',getParentRoute: () => rootRouteImport
          })
const HusselenVsTossenVsRacketTrekkenRoute = HusselenVsTossenVsRacketTrekkenRouteImport.update({
            id: '/husselen-vs-tossen-vs-racket-trekken',path: '/husselen-vs-tossen-vs-racket-trekken',getParentRoute: () => rootRouteImport
          })
const HusselochtendOrganiserenRoute = HusselochtendOrganiserenRouteImport.update({
            id: '/husselochtend-organiseren',path: '/husselochtend-organiseren',getParentRoute: () => rootRouteImport
          })
const JeugdHusselavondOrganiserenRoute = JeugdHusselavondOrganiserenRouteImport.update({
            id: '/jeugd-husselavond-organiseren',path: '/jeugd-husselavond-organiseren',getParentRoute: () => rootRouteImport
          })
const OverDeHusselAppRoute = OverDeHusselAppRouteImport.update({
            id: '/over-de-hussel-app',path: '/over-de-hussel-app',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PrivacyWebsiteRoute = PrivacyWebsiteRouteImport.update({
            id: '/privacy-website',path: '/privacy-website',getParentRoute: () => rootRouteImport
          })
const RacketTrekkenOrganiserenRoute = RacketTrekkenOrganiserenRouteImport.update({
            id: '/racket-trekken-organiseren',path: '/racket-trekken-organiseren',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ScreenshotsRoute = ScreenshotsRouteImport.update({
            id: '/screenshots',path: '/screenshots',getParentRoute: () => rootRouteImport
          })
const TennisHusselAppRoute = TennisHusselAppRouteImport.update({
            id: '/tennis-hussel-app',path: '/tennis-hussel-app',getParentRoute: () => rootRouteImport
          })
const TennisTossAppRoute = TennisTossAppRouteImport.update({
            id: '/tennis-toss-app',path: '/tennis-toss-app',getParentRoute: () => rootRouteImport
          })
const TennisclubSoftwareRoute = TennisclubSoftwareRouteImport.update({
            id: '/tennisclub-software',path: '/tennisclub-software',getParentRoute: () => rootRouteImport
          })
const TennisverenigingAppSpelersRoute = TennisverenigingAppSpelersRouteImport.update({
            id: '/tennisvereniging-app-spelers',path: '/tennisvereniging-app-spelers',getParentRoute: () => rootRouteImport
          })
const TossIndelingenSysteemRoute = TossIndelingenSysteemRouteImport.update({
            id: '/toss-indelingen-systeem',path: '/toss-indelingen-systeem',getParentRoute: () => rootRouteImport
          })
const TossavondOrganiserenRoute = TossavondOrganiserenRouteImport.update({
            id: '/tossavond-organiseren',path: '/tossavond-organiseren',getParentRoute: () => rootRouteImport
          })
const TossochtendOrganiserenRoute = TossochtendOrganiserenRouteImport.update({
            id: '/tossochtend-organiseren',path: '/tossochtend-organiseren',getParentRoute: () => rootRouteImport
          })
const WatIsHusselenRoute = WatIsHusselenRouteImport.update({
            id: '/wat-is-husselen',path: '/wat-is-husselen',getParentRoute: () => rootRouteImport
          })
const WatIsTossenRoute = WatIsTossenRouteImport.update({
            id: '/wat-is-tossen',path: '/wat-is-tossen',getParentRoute: () => rootRouteImport
          })
const SlugRegisterRoute = SlugRegisterRouteImport.update({
            id: '/$slug/register',path: '/$slug/register',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminHandleidingRoute = AuthenticatedAdminHandleidingRouteImport.update({
            id: '/admin-handleiding',path: '/admin-handleiding',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedScheduleRoute = AuthenticatedScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AuthenticatedRoute
          })
const BlogHusselavondZonderVrijwilligersRoute = BlogHusselavondZonderVrijwilligersRouteImport.update({
            id: '/blog/husselavond-zonder-vrijwilligers',path: '/blog/husselavond-zonder-vrijwilligers',getParentRoute: () => rootRouteImport
          })
const BlogMeerSpelersNaarHusselavondRoute = BlogMeerSpelersNaarHusselavondRouteImport.update({
            id: '/blog/meer-spelers-naar-husselavond',path: '/blog/meer-spelers-naar-husselavond',getParentRoute: () => rootRouteImport
          })
const NieuwsIndexRoute = NieuwsIndexRouteImport.update({
            id: '/nieuws/',path: '/nieuws/',getParentRoute: () => rootRouteImport
          })
const NieuwsSlugRoute = NieuwsSlugRouteImport.update({
            id: '/nieuws/$slug',path: '/nieuws/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedEnrollSessionIdRoute = AuthenticatedEnrollSessionIdRouteImport.update({
            id: '/enroll/$sessionId',path: '/enroll/$sessionId',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAdminHandleidingRoute: AuthenticatedAdminHandleidingRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedScheduleRoute: AuthenticatedScheduleRoute,AuthenticatedEnrollSessionIdRoute: AuthenticatedEnrollSessionIdRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R2faVerifyRoute: R2faVerifyRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AiSysteemHusselTossRoute: AiSysteemHusselTossRoute,AlgemeneVoorwaardenRoute: AlgemeneVoorwaardenRoute,AuthRoute: AuthRoute,AutomatischIndelenTennisspelersRoute: AutomatischIndelenTennisspelersRoute,ClubRegisterRoute: ClubRegisterRoute,ContactRoute: ContactRoute,DemoRoute: DemoRoute,DraaiboekHusselavondRoute: DraaiboekHusselavondRoute,EmailPreviewRoute: EmailPreviewRoute,HoeWerktHetRoute: HoeWerktHetRoute,HusselIndelingenSysteemRoute: HusselIndelingenSysteemRoute,HusselavondOrganiserenRoute: HusselavondOrganiserenRoute,HusselenVsTossenVsRacketTrekkenRoute: HusselenVsTossenVsRacketTrekkenRoute,HusselochtendOrganiserenRoute: HusselochtendOrganiserenRoute,JeugdHusselavondOrganiserenRoute: JeugdHusselavondOrganiserenRoute,OverDeHusselAppRoute: OverDeHusselAppRoute,PrivacyRoute: PrivacyRoute,PrivacyWebsiteRoute: PrivacyWebsiteRoute,RacketTrekkenOrganiserenRoute: RacketTrekkenOrganiserenRoute,ResetPasswordRoute: ResetPasswordRoute,ReviewsRoute: ReviewsRoute,ScreenshotsRoute: ScreenshotsRoute,TennisHusselAppRoute: TennisHusselAppRoute,TennisTossAppRoute: TennisTossAppRoute,TennisclubSoftwareRoute: TennisclubSoftwareRoute,TennisverenigingAppSpelersRoute: TennisverenigingAppSpelersRoute,TossIndelingenSysteemRoute: TossIndelingenSysteemRoute,TossavondOrganiserenRoute: TossavondOrganiserenRoute,TossochtendOrganiserenRoute: TossochtendOrganiserenRoute,WatIsHusselenRoute: WatIsHusselenRoute,WatIsTossenRoute: WatIsTossenRoute,SlugRegisterRoute: SlugRegisterRoute,BlogHusselavondZonderVrijwilligersRoute: BlogHusselavondZonderVrijwilligersRoute,BlogMeerSpelersNaarHusselavondRoute: BlogMeerSpelersNaarHusselavondRoute,NieuwsSlugRoute: NieuwsSlugRoute,NieuwsIndexRoute: NieuwsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)